import React, { useRef, useState, useEffect }
from 'react'
import { MapContainer, MapConsumer, TileLayer, Marker, useMapEvents, useMap, useMapEvent } from 'react-leaflet';
import './Map.css'
import FetchData from '../../../shared/fetchData'
import Grid from '@material-ui/core/Grid'
import Search from '@material-ui/icons/Search'
import 'leaflet/dist/leaflet.css'
import MapIcon from '../../../assets/images/marker-icon-2x.png'

        const MapCntnr = (props) => {
    const [position, setPosition] = useState([props.lat, props.lng])
    const [showInput, setShowInput] = useState(false)
    const [options, setOptions] = useState([])
    const [searchValue, setSearchValue] = useState([])
    const [zoom, setZoom] = useState(props.zoom)


    const customProvider = (event) => {
// search: async (inputValue) => {
        setSearchValue(event.target.value)
        if (event.target.value == '') {
            setOptions([])
        } else {
            const token = window.localStorage.getItem("token")
            var info = {
                "cityId": props.cityId,
                "text": event.target.value,
                "version": "mtpx001"
            }
            var raw = JSON.stringify(info)
            var url = 'api/v1/geonames/searchAddress'
            const inf = []
            FetchData(raw, url).then(response => response.json())
                    .then(result => {
                        result.result.map(r => {
                            inf.push({
                                // bounds: r.lat + '-' + r.lon,
                                latitude: parseFloat(r.lat),
                                longitude: parseFloat(r.lon),
                                name: r.title
                            })
                        })
                        setOptions(inf)
                    })
                    .catch(error => console.log('error', error))
        }
    }
    const showHideInput = (event) => {
        showInput == true ? setShowInput(false) : setShowInput(true)
    }
    const inputClass = showInput == true ? "MapInputOpen" : "MapInputOpenHide"
    const changeLocation = (lat, lon) => {
        props.changeLocation(lat, lon)
        setPosition([lat, lon])
        // childRef.current.flyTo([lat, lon])
        setOptions([])
        setShowInput(false)
        setSearchValue('')
        // childRef.current.flyTo([lat, lon]);
    }
    let optionList = ''
    if (options != null && options.length != 0) {
        optionList = options.map(o => {
            const lat = o.latitude
            const lon = o.longitude
            return <div key={o.latitude} className="MapOptions" onClick={(lat, lon) => changeLocation(o.latitude, o.longitude)}>
                {o.name}
            </div>
        })
    }

    function ChangeView( { center, zoom }) {
        const map = useMap();
        setZoom(zoom)
        map.setView(center, zoom);
        return null;
    }

    const Markers = () => {
        const map = useMapEvents({
            click(e) {
            },
        })
        return true;
    }

    function AddMarkerToClick() {
        const [markers, setMarkers] = useState([]);
        const map = useMapEvents({
            dragend: (e) => {
                if (props.hasSearch != false) {
                    props.latLngChangeHandler(e)
                    const newMarker = e.latlng
                    setMarkers([...markers, newMarker]);
                }
            }
        })

        return (
                <div>
                    {markers.map(marker =>
                                        <Marker position={marker}>
                                        </Marker>
                                )}
                </div>
                )
    }

    function ChangeMapView( { coords }) {
        const map = useMap();
        map.setView([props.lat, props.lng], map.getZoom());
        return null;
    }

    const content = <MapContainer
        scrollWheelZoom={false}
        className={[props.className, "MapMapContainer"].join(' ')}
        center={[props.lat, props.lng]}
        backgroundColor='red'
        zoom={props.zoom}
        >
        {props.start ? <Markers /> : ''}
        <ChangeMapView coords={position} />
        <AddMarkerToClick />
        <TileLayer
            url="https://pm2.parsimap.com/comapi.svc/tile/parsimap/{x}/{y}/{z}/a8e721a4-abbb-4849-8ec2-3262826a6e6e"
            />
        <div style={{height: '100%', width: '100%', position: 'absolute', zIndex: '400', textAlign: 'center'}}>
            <span style={{display: 'inline-block', height: '100%', verticalAlign: 'middle'}}/>
            <img src={MapIcon} style={{verticalAlign: 'middle', maxHeight: '60px', maxWidth: '60px', marginTop: '-30px'}}/>
        </div>
    
        {props.hasSearch != false ?
                    <div className="p-3 pr-4" style={{position: 'absolute', width: '50%'}}>
                        <div className="row">
                            <div onClick={showHideInput} style={{width: '8%'}}>
                                <Grid container className="root">
                                    <Search className="Mapicon MapSearch" />
                                </Grid>
                            </div>
                            <div style={{position: 'absolute', paddingRight: '11%'}}>
                                <input value={searchValue} onChange={customProvider} className={inputClass} name="search" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="MapOptionCntnr">
                                <div className="MapOptionList">
                                    {optionList}
                                </div>
                            </div>
                        </div>
                    </div>
                        : ''}
    </MapContainer>
    return (
            content
            )
}
export default MapCntnr
